export default __webpack_public_path__ + "audio/uwa.06b83173.mp3";